import { ProjectVehicle, Vehicle, VehicleTakeForPlanner, VehicleUploadFileType, VehicleUseMode } from '@common/types';

export const getTakeForPlanner = (vehicle: Vehicle | VehicleUploadFileType, projectVehicle?: ProjectVehicle): number => {
  return vehicle.UseMode && Number(vehicle.UseMode) !== VehicleUseMode.NotUsed
    ? VehicleTakeForPlanner.Taken
    : Number(projectVehicle?.TakeForPlanner ?? VehicleTakeForPlanner.NotTaken);
};
